import i18n from './i18n';
import {
  buildUrlWithLangParam,
  i18nLangToThemeLocale,
  normalizeAppLanguage,
  setLangCookie,
} from './languageConstants';

/**
 * 프론트 i18next · localStorage · lang 쿠키 · theme locale · document.lang 동기 적용
 * @param {string} lang - ko | en
 * @param {{ onThemeLocale?: (locale: string) => void, updateUrl?: boolean, pathname?: string, search?: string }} [options]
 */
export function applyAppLanguage(lang, options = {}) {
  const normalized = normalizeAppLanguage(lang) || 'ko';

  try {
    localStorage.setItem('i18nextLng', normalized);
  } catch {
    // ignore quota / private mode
  }

  setLangCookie(normalized);

  if (typeof document !== 'undefined') {
    document.documentElement.lang = normalized;
  }

  if (i18n.language !== normalized) {
    i18n.changeLanguage(normalized);
  }

  options.onThemeLocale?.(i18nLangToThemeLocale(normalized));

  if (options.updateUrl && typeof window !== 'undefined') {
    const pathname = options.pathname ?? window.location.pathname;
    const search = options.search ?? window.location.search;
    const next = buildUrlWithLangParam(pathname, search, normalized);
    window.history.replaceState(window.history.state, '', next);
  }

  return normalized;
}
